import axios from '@/libs/api.request'
import urlObj from '@/config/env.js'

// 询价列表
export function getinquirelist(data, params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/enquiry/enquiryList',
    method: 'post',
    data,
    params
  })
}
// 询价加入购物车
export function getenquiryadd(data) {
  return axios.request({
    url: urlObj.wss + 'wss-order/enquiryCart/createEnquiryCart',
    method: 'post',
    data
  })
}
// 询价人
export function getinquireman(params) {
  return axios.request({
    url: urlObj.crm + 'uims-oauth/employee/enquiry',
    method: 'get',
    params
  })
}

// 报价列表
export function getquotelist(data, params) {
  return axios.request({
    url: urlObj.wss + 'wss-part/enquiry/offerList',
    method: 'post',
    data,
    params
  })
}
// 报价/ 重新报价
export function getquotexx(data) {
  return axios.request({
    url: urlObj.wss + 'wss-part/enquiry/makeOffers',
    method: 'put',
    data
  })
}
